var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{staticStyle:{"padding-top":"0px"}},[_c('div',{attrs:{"slot":"conteudo"},slot:"conteudo"})])}
var staticRenderFns = []

export { render, staticRenderFns }